import { faLock } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { UnlockPremiumAction } from './tracking'

const useStyles = makeStyles<Theme, { paddingOffsetSet: boolean }>((theme) => ({
  button: {
    margin: theme.spacing(2),
    marginBottom: ({ paddingOffsetSet }) => (paddingOffsetSet ? `0` : theme.spacing(2)), // Account for the padding offset of the overlay.
    color: theme.palette.secondary.main,
    backgroundColor: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.secondary.light,
    },
    width: 'fit-content',
  },
}))

export default function UnlockPremiumButton({
  trackingIdPlacement,
  onClick,
  paddingOffsetSet = false,
}: {
  trackingIdPlacement: UnlockPremiumAction
  onClick: () => void
  paddingOffsetSet?: boolean
}) {
  const classes = useStyles({ paddingOffsetSet })
  return (
    <Button
      variant="outlined"
      color="secondary"
      className={classes.button}
      onClick={onClick}
      startIcon={<FontAwesomeIcon icon={faLock} />}
      // Used for tracking in CSM platform
      data-action-family="unlock-premium-hs-explorer"
      data-action-id={`unlock-premium-hs-explorer-${trackingIdPlacement}`}
    >
      Unlock Premium
    </Button>
  )
}
